import { UseFormRegister } from 'react-hook-form'
import type { Book as BookType } from 'src/subscribe'
import Book from 'src/Subscribe_/Book'
import type { FieldValues } from './RecipientsInformation'

export default function WhichBookShouldTheSubscriptionStartWith({
  register,
  startableBooks,
}: {
  register: UseFormRegister<FieldValues>
  startableBooks: BookType[]
}) {
  console.log('startableBooks[0].number = ', startableBooks[0]!.number)
  console.log(
    'typeof startableBooks[0].number = ',
    typeof startableBooks[0]!.number
  )
  return (
    <div>
      <fieldset className="form-item">
        <legend>
          <span>Which book should the subscription start with?</span>
        </legend>
        <div>
          <div className="" id="edit-starting-book-number">
            {startableBooks.map((sb) => (
              <div className="form-item js-form-type-radio" key={sb.number}>
                <input
                  className="form-radio"
                  id={`edit-starting-book-number-${sb.number}`}
                  type="radio"
                  value={sb.number}
                  {...register('starting_book_number')}
                />
                <label htmlFor={`edit-starting-book-number-${sb.number}`}>
                  <span>Subscription starts with </span>
                  <Book book={sb} />
                </label>
              </div>
            ))}
          </div>
        </div>
      </fieldset>
    </div>
  )
}
